<template>
  <div class="nopads" style="min-height: 40vh">
      <div class="form-check form-check-inline">
          <input
              type="radio"
              id="radio-1"
              v-model="taskType"
              class="form-check-input"
              name="radio-options"
              value="1"
          />
          <label class="form-check-label" for="radio-1">Kokonaishintaiset</label>
      </div>
      <div class="form-check form-check-inline">
          <input
              type="radio"
              id="radio-2"
              v-model="taskType"
              class="form-check-input"
              name="radio-options"
              value="2"
          />
          <label class="form-check-label" for="radio-2">Yksikköhintaiset</label>
      </div>
    <div class="col-12 nopads">
        <multiselect
            v-model="selectedTask"
            :placeholder="$t('orders.select_task')"
            :deselect-label="$t('common.remove_selection')"
            :select-label="$t('common.select')"
            :close-on-select="true"
            :multiple="false"
            :custom-label="taskLabel"
            track-by="id"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :options="taskOptions"
        >
            <template #singleLabel="props">
                <div class="col-12 nopads">
      <span
          class="option__title"
          style="font-weight: 400"
      >
        {{ props.option.id }} - {{ props.option.selite }} ({{ props.option.yksikko }})
      </span>
                </div>
            </template>

            <template #option="props">
                <div class="col-12 nopads">
      <span
          class="option__title"
          style="font-weight: 400"
      >
        {{ props.option.id }} - {{ props.option.selite }} ({{ props.option.yksikko }})
      </span>
                </div>
            </template>

            <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
            </template>

            <template #noOptions>
                <span>{{ $t('common.no_results') }}</span>
            </template>
        </multiselect>
    </div>
  </div>
</template>

<script>


export default {
    name: 'ExternalTaskSelector',
    props: {
        tasks: {
            type: Object,
            default() {
                return ({})
            }
        }
    },
    data: function () {
        return {
            taskType: 1,
            selectedTask: null,
            taskOptions: []
        }
    },
    watch: {
        taskType() {
            this.initTaskOptions()
        },
        selectedTask() {
            this.$emit('notifyIsTaskSelected', this.selectedTask != null);
        }
    },
    mounted() {
        this.initTaskOptions()
    },
    methods: {
        taskLabel(option) {
            if (!option) {
                return '';
            }
            return `${option.id || ''} ${option.selite || ''}`;
        },
        initTaskOptions(){
            let items = parseInt(this.taskType) === 1 ? this.tasks.kokonaishintaiset : this.tasks.yksikkohintaiset
            this.taskOptions = []
            items ? items.forEach(task => this.taskOptions.push(task.tehtava)) : null
        },
        getSelectedTask() {
            this.selectedTask.type = this.taskType
            return this.selectedTask
        }
    }
}
</script>
<style>
</style>
